import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getBackendUrl } from "../utils/paths";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  function resolveImage(path) {
    if (!path) return null;
    if (/^https?:\/\//i.test(path)) return path;
    if (path.startsWith('/backend/uploads/')) return getBackendUrl(path);
    if (path.startsWith('/uploads/')) return getBackendUrl(`/backend${path}`);
    return getBackendUrl(path);
  }
  useEffect(() => {
    fetch(getBackendUrl('/backend/api/public/blogs.php'))
      .then((r) => r.json())
      .then((d) => setPosts(Array.isArray(d.items) ? d.items : []))
      .catch(() => {});
  }, []);
  return (
    <>
      <Header />

      <>
        {/*Start Page Header*/}

        <section className="page-header">
          <div
            className="page-header__bg"
            style={{
              backgroundImage:
                "url(assets/images/backgrounds/page-header-bg.jpg)",
            }}
          ></div>

          <div className="shape1 float-bob-x">
            <img
              src="assets/images/shapes/page-header-shape1.png"
              alt=""
              style={{ filter: "hue-rotate(90deg)" }}
            />
          </div>

          <div className="shape2">
            <img
              src="assets/images/shapes/page-header-shape2.png"
              alt=""
              style={{ filter: "hue-rotate(90deg)" }}
            />
          </div>

          <div className="container">
            <div className="page-header__inner">
              <h2 className="wow fadeInDown" data-wow-duration="1500ms">
                Blogs
              </h2>
            </div>
          </div>
        </section>

        {/*End Page Header*/}

        {/*Start Blog One*/}

        <section className="blog-one blog-one--two blog-page">
          <div className="container">
            <div className="row">
              {posts.map((b, i) => (
                <div
                  key={`dyn-${b.id}`}
                  className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                  data-wow-delay={`${0.1 + i * 0.1}s`}
                >
                  <div className="blog-one__single">
                    <div className="blog-one__single-img">
                      {b.image_path ? (
                        <img src={resolveImage(b.image_path)} alt="" />
                      ) : (
                        <img src="assets/images/blog/placeholder.jpg" alt="" />
                      )}
                      <Link to={`/blog/${b.slug || b.id}`} className="blog-one__link">
                        <span className="icon-plus" />
                      </Link>
                    </div>
                    <div className="blog-one__single-content">
                      <div className="blog-one__single-content-top">
                        <div className="date-box">
                          <h2>
                            {new Date(b.created_at).getDate()} <br /> <span>{new Date(b.created_at).toLocaleString('en-US', { month: 'short', year: '2-digit' })}</span>
                          </h2>
                        </div>
                      </div>
                      <h2>{b.title}</h2>
                      <div className="btn-box">
                        <Link to={`/blog/${b.slug || b.id}`} className="thm-btn">
                          Read More <span className="icon-diagonal-arrow1" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {/*Start Blog 1 One Single*/}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.1s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img src="assets/images/blog/7Myths.jpg" alt="" />

                    <a href="" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          12 <br /> <span>Apr 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>Truths and Myths about Crowdfunding </h2>

                    <div className="btn-box">
                      <Link to="/truth-myth" className="thm-btn">
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/*End Blog One Single*/}

              {/*Start Blog One Single*/}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.3s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img src="assets/images/blog/mn.jpg" alt="" />

                    <a href="" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          22 <br /> <span>Sep 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>Crowdfunding has rapidly emerged</h2>

                    <div className="btn-box">
                      <Link to="/crowfunding" className="thm-btn">
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/*End Blog One Single*/}

              {/*Start Blog One Single*/}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img src="assets/images/blog/5-ways_1.jpg" alt="" />

                    <a href="blog-details.html" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          20 <br /> <span>Apr 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>A New Hope for Disabled Children</h2>

                    <div className="btn-box">
                      <Link
                        to="/A-New-Hope-for-Disabled-Children"
                        className="thm-btn"
                      >
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/*End Blog One Single*/}

              {/*Start Blog One Single*/}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.1s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img
                      src="assets/images/blog/can-you-redefine-disability_1.jpg"
                      alt=""
                    />

                    <a href="" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          8 <br /> <span>Apr 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>
                      Redefining Disability: Can you do it? Because we did.
                    </h2>

                    <div className="btn-box">
                      <Link
                        to="/Redefining-Disability-Can-you-do-it-Because-we-did"
                        className="thm-btn"
                      >
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/*End Blog One Single*/}

              {/*Start Blog One Single*/}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.3s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img src="assets/images/blog/story3.jpg" alt="" />

                    <a href="blog-details.html" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          22 <br /> <span>Aug 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>Sumita Overcoming Mental Retardation</h2>

                    <div className="btn-box">
                      <Link
                        to="/Sumita-Overcoming-Obstacles"
                        className="thm-btn"
                      >
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/*End Blog One Single*/}

              {/*Start Blog One Single*/}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img src="assets/images/blog/story2_3.jpg" alt="" />

                    <a href="" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          24 <br /> <span>Apr 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>
                      Gupta Overcoming Challenges with Vikash Foundation's
                    </h2>

                    <div className="btn-box">
                      <Link
                        to="/Gupta-Overcoming-Challenges-with-Vikash-Foundation-Support"
                        className="thm-btn"
                      >
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* blog7 */}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img src="assets/images/blog/story1.jpg" alt="" />

                    <a href="blog-details.html" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          22 <br /> <span>Aug 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>Aniketa's Heartfelt Journey Vikash Foundation</h2>

                    <div className="btn-box">
                      <Link
                        to="/Aniketa-Heartfelt-Journey-Vikash-Foundation"
                        className="thm-btn"
                      >
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* blog8 */}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img src="assets/images/blog/rehabilation.jpg" alt="" />

                    <a href="" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          4 <br /> <span>Oct 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>Rehabilation services enhance lives</h2>

                    <div className="btn-box">
                      <Link to="/rehab" className="thm-btn">
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* blog9 */}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img src="assets/images/blog/facts.jpg" alt="" />

                    <a href="" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          4 <br /> <span>Oct 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>
                      <a href="">Inclusive Rehabilitation Services</a>
                    </h2>

                    <div className="btn-box">
                      <Link to="/inclusive-rehab-services" className="thm-btn">
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* blog10 */}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img src="assets/images/blog/tyi.jpg" alt="" />

                    <a href="" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          17 <br /> <span>Oct 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>Intervention Transforms Lives of Premature Babies</h2>

                    <div className="btn-box">
                      <Link to="/tyi" className="thm-btn">
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* blog11 */}

              <div
                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="blog-one__single">
                  <div className="blog-one__single-img">
                    <img src="assets/images/blog/Emp.jpg" alt="" />

                    <a href="blog-details.html" className="blog-one__link">
                      <span className="icon-plus" />
                    </a>
                  </div>

                  <div className="blog-one__single-content">
                    <div className="blog-one__single-content-top">
                      <div className="date-box">
                        <h2>
                          17 <br /> <span>Oct 25</span>
                        </h2>
                      </div>
                    </div>

                    <h2>Empowering Disabled Children from Odisha</h2>

                    <div className="btn-box">
                      <Link to="/emp" className="thm-btn">
                        Read More <span className="icon-diagonal-arrow1" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/*End Blog One Single*/}
            </div>

            <ul className="styled-pagination text-center clearfix">
              <li className="arrow prev active">
                <a href="#">
                  <span className="icon-right-chevron" />
                </a>
              </li>

              <li>
                <a href="#">01</a>
              </li>

              <li>
                <a href="#">02</a>
              </li>

              <li>
                <a href="#">03</a>
              </li>

              <li className="arrow next">
                <a href="#">
                  <span className="icon-right-chevron1" />
                </a>
              </li>
            </ul>
          </div>
        </section>

        {/*End Blog One*/}
      </>

      <Footer />

      {/* /.page-wrapper */}

      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>

        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};

export default Blog;
